import React from 'react'

function Accueil() {
    return (
        <>
            {/* General Report */}
            <div className="gap-6 grid grid-cols-4 xl:grid-cols-1">


                {/* card */}
                <div className="report-card">
                    <div className="card">
                        <div className="flex flex-col card-body">

                            {/* top */}
                            <div className="flex flex-row justify-between items-center">
                                <div className="text-indigo-700 fa-shopping-cart fad h6"></div>
                                <span className="bg-teal-400 rounded-full text-white text-xs badge">
                                    12%
                                    <i className="ml-1 fa-chevron-up fal"></i>
                                </span>
                            </div>
                            {/* end top */}

                            {/* bottom */}
                            <div className="mt-8">
                                <h1 className="num-4 h5"></h1>
                                <p>Produits vendus</p>
                            </div>
                            {/* end bottom */}

                        </div>
                    </div>
                    <div className="bg-white mx-4 p-1 border border-t-0 rounded rounded-t-none footer"></div>
                </div>
                {/* end card */}


                {/* card */}
                <div className="report-card">
                    <div className="card">
                        <div className="flex flex-col card-body">

                            {/* top */}
                            <div className="flex flex-row justify-between items-center">
                                <div className="text-red-700 fa-store fad h6"></div>
                                <span className="bg-red-400 rounded-full text-white text-xs badge">
                                    6%
                                    <i className="ml-1 fa-chevron-down fal"></i>
                                </span>
                            </div>
                            {/* end top */}

                            {/* bottom */}
                            <div className="mt-8">
                                <h1 className="num-4 h5"></h1>
                                <p>Plats vendus</p>
                            </div>
                            {/* end bottom */}

                        </div>
                    </div>
                    <div className="bg-white mx-4 p-1 border border-t-0 rounded rounded-t-none footer"></div>
                </div>
                {/* end card */}


                {/* card */}
                <div className="report-card">
                    <div className="card">
                        <div className="flex flex-col card-body">

                            {/* top */}
                            <div className="flex flex-row justify-between items-center">
                                <div className="text-yellow-600 fa-sitemap fad h6"></div>
                                <span className="bg-teal-400 rounded-full text-white text-xs badge">
                                    72%
                                    <i className="ml-1 fa-chevron-up fal"></i>
                                </span>
                            </div>
                            {/* end top */}

                            {/* bottom */}
                            <div className="mt-8">
                                <h1 className="num-4 h5"></h1>
                                <p>total vendus</p>
                            </div>
                            {/* end bottom */}

                        </div>
                    </div>
                    <div className="bg-white mx-4 p-1 border border-t-0 rounded rounded-t-none footer"></div>
                </div>
                {/* end card */}


                {/* card */}
                <div className="report-card">
                    <div className="card">
                        <div className="flex flex-col card-body">

                            {/* top */}
                            <div className="flex flex-row justify-between items-center">
                                <div className="text-green-700 fa-users fad h6"></div>
                                <span className="bg-teal-400 rounded-full text-white text-xs badge">
                                    150%
                                    <i className="ml-1 fa-chevron-up fal"></i>
                                </span>
                            </div>
                            {/* end top */}

                            {/* bottom */}
                            <div className="mt-8">
                                <h1 className="num-4 h5"></h1>
                                <p>Total commandes</p>
                            </div>
                            {/* end bottom */}

                        </div>
                    </div>
                    <div className="bg-white mx-4 p-1 border border-t-0 rounded rounded-t-none footer"></div>
                </div>
                {/* end card */}


            </div>
            {/* End General Report */}

            {/* strat Analytics */}
            <div className="gap-6 grid grid-cols-2 xl:grid-cols-1 mt-6">

                {/* update section */}
                <div className="bg-teal-400 shadow-md border-teal-400 text-white card">
                    <div className="flex flex-row card-body">

                        {/* image */}
                        <div className="flex justify-center items-center w-40 h-40 img-wrapper">
                            <img src="assets/img/happy.svg" alt="img title" />
                        </div>
                        {/* end image */}

                        {/* info */}
                        <div className="ml-10 py-2">
                            <h1 className="h6">Excellent travail, Soulé!</h1>
                            <p className="text-white text-xs">Tu es finit meilleur vendeur de la semaine</p>

                            <ul className="mt-4">
                                <li className="font-light text-sm"><i className="mr-2 mb-2 fa-check-double fad"></i> Finish Dashboard Design</li>
                                <li className="font-light text-sm"><i className="mr-2 mb-2 fa-check-double fad"></i> Fix Issue #74</li>
                                <li className="font-light text-sm"><i className="mr-2 fa-check-double fad"></i> Publish version 1.0.6</li>
                            </ul>
                        </div>
                        {/* end info */}

                    </div>
                </div>
                {/* end update section */}

                {/* carts */}
                <div className="flex flex-col">

                    {/* alert */}
                    <div className="mb-6 alert alert-dark">
                        Hi! Wait A Minute . . . . . . Follow Me On Twitter
                        <a className="ml-2" target="_blank" href="https://twitter.com/MohamedSaid__">@moesaid</a>
                    </div>
                    {/* end alert */}

                    {/* charts */}
                    <div className="gap-6 grid grid-cols-2 h-full">

                        <div className="card">
                            <div className="flex flex-row justify-between px-4 py-3">
                                <h1 className="h6">
                                    <span className="num-4"></span>k
                                    <p>page view</p>
                                </h1>

                                <div className="flex justify-center items-center bg-teal-200 border border-teal-300 rounded-full w-10 h-10 text-teal-700">
                                    <i className="fa-eye fad"></i>
                                </div>
                            </div>
                            <div className="analytics_1"></div>
                        </div>

                        <div className="card">
                            <div className="flex flex-row justify-between px-4 py-3">
                                <h1 className="h6">
                                    <span className="num-2"></span>k
                                    <p>Unique Users</p>
                                </h1>

                                <div className="flex justify-center items-center border-indigo-300 bg-indigo-200 border rounded-full w-10 h-10 text-indigo-700">
                                    <i className="fa-users-crown fad"></i>
                                </div>
                            </div>
                            <div className="analytics_1"></div>
                        </div>

                    </div>
                    {/* charts    */}

                </div>
                {/* end charts */}


            </div>
            {/* end Analytics */}

            {/* Sales Overview */}
            <div className="mt-6 card">

                {/* header */}
                <div className="flex flex-row justify-between card-header">
                    <h1 className="h6">Sales Overview</h1>

                    <div className="flex flex-row justify-center items-center">

                        <a href="">
                            <i className="mr-6 fa-chevron-double-down fad"></i>
                        </a>

                        <a href="">
                            <i className="fa-ellipsis-v fad"></i>
                        </a>

                    </div>

                </div>
                {/* end header */}

                {/* body */}
                <div className="gap-6 grid grid-cols-2 lg:grid-cols-1 card-body">

                    <div className="p-8">
                        <h1 className="h2">5,337</h1>
                        <p className="font-medium text-black">Sales this month</p>

                        <div className="flex items-center mt-20 mb-2">
                            <div className="bg-green-200 mr-3 px-3 py-1 rounded text-green-900">
                                <i className="fa fa-caret-up"></i>
                            </div>
                            <p className="text-black"><span className="num-2 text-green-400"></span><span className="text-green-400">% more sales</span> in comparison to last month.</p>
                        </div>

                        <div className="flex items-center">
                            <div className="bg-red-200 mr-3 px-3 py-1 rounded text-red-900">
                                <i className="fa fa-caret-down"></i>
                            </div>
                            <p className="text-black"><span className="num-2 text-red-400"></span><span className="text-red-400">% revenue per sale</span> in comparison to last month.</p>
                        </div>

                        <a href="#" className="btn-shadow mt-6">view details</a>

                    </div>

                    <div className="">
                        <div id="sealsOverview"></div>
                    </div>

                </div>
                {/* end body */}

            </div>
            {/* end Sales Overview */}

            {/* start numbers */}
            <div className="gap-6 grid grid-cols-5 xl:grid-cols-2">

                {/* card */}
                <div className="mt-6 card">
                    <div className="flex items-center card-body">

                        <div className="bg-indigo-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-wallet fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> Sales</h1>
                            <p className="text-xs"><span className="num-2"></span> payments</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="mt-6 card">
                    <div className="flex items-center card-body">

                        <div className="bg-green-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-shopping-cart fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> Orders</h1>
                            <p className="text-xs"><span className="num-2"></span> items</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="mt-6 xl:mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-yellow-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-blog fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> posts</h1>
                            <p className="text-xs"><span className="num-2"></span> active</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="mt-6 xl:mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-red-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-comments fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> comments</h1>
                            <p className="text-xs"><span className="num-2"></span> approved</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="xl:col-span-2 mt-6 xl:mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-pink-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-user fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> memebrs</h1>
                            <p className="text-xs"><span className="num-2"></span> online</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

            </div>
            {/* end nmbers */}

            {/* start quick Info */}
            <div className="gap-6 grid grid-cols-3 xl:grid-cols-1 mt-6">


                {/* Browser Stats */}
                <div className="card">
                    <div className="card-header">Browser Stats</div>

                    {/* brawser */}
                    <div className="flex flex-row justify-between items-center p-6 border-b text-gray-600">
                        <div className="flex items-center">
                            <i className="mr-4 fa-chrome fab"></i>
                            <h1>google chrome</h1>
                        </div>
                        <div>
                            <span className="num-2"></span>%
                        </div>
                    </div>
                    {/* end brawser */}

                    {/* brawser */}
                    <div className="flex flex-row justify-between items-center p-6 border-b text-gray-600">
                        <div className="flex items-center">
                            <i className="mr-4 fa-firefox fab"></i>
                            <h1>firefox</h1>
                        </div>
                        <div>
                            <span className="num-2"></span>%
                        </div>
                    </div>
                    {/* end brawser */}

                    {/* brawser */}
                    <div className="flex flex-row justify-between items-center p-6 border-b text-gray-600">
                        <div className="flex items-center">
                            <i className="mr-4 fa-internet-explorer fab"></i>
                            <h1>internet explorer</h1>
                        </div>
                        <div>
                            <span className="num-2"></span>%
                        </div>
                    </div>
                    {/* end brawser */}

                    {/* brawser */}
                    <div className="flex flex-row justify-between items-center p-6 border-b-0 text-gray-600">
                        <div className="flex items-center">
                            <i className="mr-4 fa-safari fab"></i>
                            <h1>safari</h1>
                        </div>
                        <div>
                            <span className="num-2"></span>%
                        </div>
                    </div>
                    {/* end brawser */}

                </div>
                {/* end Browser Stats */}

                {/* Start Recent Sales */}
                <div className="col-span-2 xl:col-span-1 card">
                    <div className="card-header">Recent Sales</div>

                    <table className="w-full text-left table-auto">
                        <thead>
                            <tr>
                                <th className="px-4 py-2 border-r"></th>
                                <th className="px-4 py-2 border-r">product</th>
                                <th className="px-4 py-2 border-r">price</th>
                                <th className="px-4 py-2">date</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600">

                            <tr>
                                <td className="px-4 py-2 border border-l-0 text-center text-green-500"><i className="fa-circle fad"></i></td>
                                <td className="px-4 py-2 border border-l-0">Lightning to USB-C Adapter Lightning.</td>
                                <td className="px-4 py-2 border border-l-0">$<span className="num-2"></span></td>
                                <td className="px-4 py-2 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                            </tr>
                            <tr>
                                <td className="px-4 py-2 border border-l-0 text-center text-yellow-500"><i className="fa-circle fad"></i></td>
                                <td className="px-4 py-2 border border-l-0">Apple iPhone 8.</td>
                                <td className="px-4 py-2 border border-l-0">$<span className="num-2"></span></td>
                                <td className="px-4 py-2 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                            </tr>
                            <tr>
                                <td className="px-4 py-2 border border-l-0 text-center text-green-500"><i className="fa-circle fad"></i></td>
                                <td className="px-4 py-2 border border-l-0">Apple MacBook Pro.</td>
                                <td className="px-4 py-2 border border-l-0">$<span className="num-2"></span></td>
                                <td className="px-4 py-2 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                            </tr>
                            <tr>
                                <td className="px-4 py-2 border border-l-0 text-center text-red-500"><i className="fa-circle fad"></i></td>
                                <td className="px-4 py-2 border border-l-0">Samsung Galaxy S9.</td>
                                <td className="px-4 py-2 border border-l-0">$<span className="num-2"></span></td>
                                <td className="px-4 py-2 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                            </tr>
                            <tr>
                                <td className="px-4 py-2 border border-l-0 text-center text-yellow-500"><i className="fa-circle fad"></i></td>
                                <td className="px-4 py-2 border border-l-0">Samsung Galaxy S8 256GB.</td>
                                <td className="px-4 py-2 border border-l-0">$<span className="num-2"></span></td>
                                <td className="px-4 py-2 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                            </tr>
                            <tr>
                                <td className="px-4 py-2 border border-b-0 border-l-0 text-center text-green-500"><i className="fa-circle fad"></i></td>
                                <td className="px-4 py-2 border border-b-0 border-l-0">apple watch.</td>
                                <td className="px-4 py-2 border border-b-0 border-l-0">$<span className="num-2"></span></td>
                                <td className="px-4 py-2 border border-r-0 border-b-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                {/* End Recent Sales */}


            </div>
            {/* end quick Info */}
        </>
    )
}

export default Accueil